import { CancelToken } from 'axios';
import { IConfiguration, configuration } from '../../../../../../configuration';
import { SecureApiService } from '../../../../../../api-service/secure-api-service';
import { TemplateListItemViewModel } from './template-list-item-view-model';
import { ITemplatesApiService } from './templates-api.service.interface';
import {
  GetEditableContentRequest,
  ICitizenCommunicationTemplatesClient,
  GetPdfRequest,
  GetTemplateByTemplateCodeRequest,
  GetTemplatesByCategoriesRequest,
  GetTemplatesByCategoryRequest,
  GetCitizenTemplatesRequest,
  GetServiceProviderLetterTemplatesRequest,
  GetServiceProviderDocumentTemplatesRequest,
} from '../../../../../../api-service/clients';
import { moduleClientFactory } from '../../../../../../api-service/module-client-factory';

export class TemplatesApiService implements ITemplatesApiService {
  private readonly configuration: IConfiguration = configuration;
  private readonly secureApiService: SecureApiService;
  private readonly templatesClient: ICitizenCommunicationTemplatesClient;

  constructor() {
    this.secureApiService = new SecureApiService();
    this.templatesClient = moduleClientFactory.createCitizenCommunicationTemplatesClient();
  }
  async getServiceProviderLetterTemplateTypes(request: GetServiceProviderLetterTemplatesRequest, cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getServiceProviderLetterTemplates({ serviceProviderId: request.serviceProviderId }, cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }
  async getServiceProviderDocumentTemplateTypes(request: GetServiceProviderDocumentTemplatesRequest, cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getServiceProviderDocumentTemplates({ serviceProviderId: request.serviceProviderId }, cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }
  async getCitizenTemplateTypes(request: GetCitizenTemplatesRequest, cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getCitizenTemplates({ caseId: request.caseId }, cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }

  async getActivityTemplateTypes(cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getActivityTemplates(cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }

  async getEditableContent(request: GetEditableContentRequest) {
    return (await this.templatesClient.getEditableContent(request)).content || '';
  }

  async getPdf(request: GetPdfRequest) {
    const data = await this.templatesClient.getPdf(request);
    return new Blob([data.data], { type: 'application/pdf' });
  }

  async getCrowdLetterTemplateTypes(cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getCrowdLetterTemplates(cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }

  async getTemplateByTemplateCode(request: GetTemplateByTemplateCodeRequest, cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getTemplateByTemplateCode(request, cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }

  async getTemplatesByCategory(request: GetTemplatesByCategoryRequest, cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getTemplatesByCategory(request, cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }

  async getTemplatesByCategories(request: GetTemplatesByCategoriesRequest, cancelToken?: CancelToken) {
    const { templates } = await this.templatesClient.getTemplatesByCategories(request, cancelToken);
    return templates?.map(t => t as TemplateListItemViewModel) ?? [];
  }
}
